
import * as React from "react";
import classNames from "classnames";
import withStyles, { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { Droppable } from '../react-beautiful-dnd';
import { TagCard } from './TagCard'
import { PhaseTag } from "../../models/PhaseTag";
import { Trade } from "../../models/Trade";
import moment, { Moment } from 'moment'
import { Tag } from "../../models/Tag";

import { lightBlue, teal, lightGreen } from "@material-ui/core/colors";
import { styles } from '../../containers/dockPadStyle'

import { ContextMenuTrigger } from "rctx-contextmenu";
import { uiActions } from "../../actions/ui.actions";
import { ThunkDispatch } from "redux-thunk";
import { compose } from "redux";
import { connect } from "react-redux";
import {  isHistogramOpen, getMaxIndex, getRowGroups, getLocalRowGroupStarts, getClosedRowGroups, getRowGroupStarts } from "../../selectors/lookahead.selector";
import TrackVisibility from '../react-on-screen';
import { getSize, getZoomAmount, defaultZoom } from "./Zoom.util";
import Typography from "@material-ui/core/Typography";
import ButtonBase from '@material-ui/core/ButtonBase';
import { lookaheadActions } from "../../actions/lookahead.actions";
import { RowGroup } from "../../models/Lookahead";
import {Animated} from "react-animated-css";

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { ROW_MENU_TYPE } from "../RowContextMenu";
import { ContextMenu, ContextMenuItem } from "rctx-contextmenu";
import { dialogActions } from "../../actions/dialog.actions";
import { CodeSharp } from "@material-ui/icons";
import fontColorContrast from 'font-color-contrast';
import MenuIcon from '@material-ui/icons/Menu';
const _ = require('lodash')

export enum  ColumnType {
    Lookahead='Lookahead',
    PhasePlan='PhasePlan'
}

interface ColumnProps {
    classes: ClassNameMap;
    zoomStep: number;
    ref:any;
    onRowSelect: (row: number) => void;
    onToggleRowGroup: (row:number) => void;
    maxIndex: number;
    rowGroups: Record<string, RowGroup>,
    rowGroupStarts: number[],
    closedRowGroups: number[],
    ungroupRows: (row: number) => void,
    groupRows: (row:number) => void,
    openRowCountDialog: (row:number) => void,
    moveRowGroup: (row: number, direction: string) => void,
    addRowGroup: (row: number, direction: string) => void,
    moveGroup: (row:number, direction:string) => void
    deleteRowGroup: (row: number) => void,
}

type State = {
    sideOpen: boolean
}

class _RowCountColumn extends React.Component<ColumnProps, State> {
    state = {
        sideOpen: false
    }
    renderTitle = () => {
        const { classes } = this.props
        const { titleFontSize } = getSize(getZoomAmount(this.props.zoomStep))

        
        return(
            <div onClick={this.openSide} className={classNames(classes.RowCounterTitleContainer, 'ColumnTitle')}>
                <MenuIcon style={{color: "#C4C4C4"}}  />
            </div>
        )
        
    }

    openSide = () => {
        this.setState({
            sideOpen: !this.state. sideOpen
        })
    }

    onColumnClick = (index:number, e) => {
        if(!e.defaultPrevented) {
            this.props.onRowSelect(index)
        }
    }

    toggleGroupBtn = (index: number, e) => {
        e.preventDefault();
        e.stopPropagation()
        const { onToggleRowGroup } = this.props
        onToggleRowGroup(index)
    }

    renderGroupButtonIcon = (index:number, rowGroup: RowGroup) => {
        const { closedRowGroups, classes } = this.props

        const closedRowGroupsSet = new Set<number>(closedRowGroups)

        const rowBackgroundColor = (!!rowGroup && !!rowGroup.color) ? rowGroup.color : "#fff"

        const fontText = (!!rowGroup && !!rowGroup.color) ? fontColorContrast(rowBackgroundColor) : "#C4C4C4"

        if(closedRowGroupsSet.has(index)) {
            return (
                <AddIcon style={{ color: fontText }} />
            )
        } else {
            return (
                <RemoveIcon style={{ color: fontText }} />
            )
        }
    }

    renderGroupButtonDivider = (index:number) => {
        const { closedRowGroups, classes } = this.props

        const closedRowGroupsSet = new Set<number>(closedRowGroups)
        if(!closedRowGroupsSet.has(index)) {
            return (
                <div className={classes.GroupButtonDivider} />
            )
        }
    }

    getFontColor = (rowGroup: RowGroup) => {
        const rowBackgroundColor = (!!rowGroup && !!rowGroup.color) ? rowGroup.color : "#fff"

        const fontText = (!!rowGroup && !!rowGroup.color) ? fontColorContrast(rowBackgroundColor) : ""

        return fontText
    }

    groupButton = (index: number, rowGroup: RowGroup) => {
        const { rowGroupStarts, classes } = this.props


        const fontText = this.getFontColor(rowGroup)

        const rowGroupSet = new Set<number>(rowGroupStarts)
        if(rowGroupSet.has(index)) {
            return (
                <div className={classes.GroupButtonContainer}>
                    <div onClick={(e) => this.toggleGroupBtn(index, e)} style={{borderColor: fontText}} className={classes.GroupButton}>
                        {this.renderGroupButtonIcon(index, rowGroup)}
                    </div>
                    {this.renderGroupButtonDivider(index)}
                </div>
            )
        
        }
    }

    renderTopGroupIndicator = (index:number, rowGroup: RowGroup) => {
        const { classes, rowGroups, closedRowGroups } = this.props

        const closedRowGroupsSet = new Set<number>(closedRowGroups)

        const rowBackgroundColor = (!!rowGroup && !!rowGroup.color) ? rowGroup.color : "#fff"

        const fontText = (!!rowGroup && !!rowGroup.color) ? fontColorContrast(rowBackgroundColor) : "#C4C4C4"

        let found = false

        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            const start = parseInt(rowGroup.start)
            if(!closedRowGroupsSet.has(start) && index > start && index <= rowGroup.end) {
                found = true
            }
        })

        if(found) {
            return (
                <div style={{backgroundColor: fontText}} className={classes.GroupButtonDivider} />
            )
        }
    }

    renderBottomGroupIndicator = (index:number, rowGroup: RowGroup) => {
        const { classes, rowGroups, closedRowGroups } = this.props

        const rowBackgroundColor = (!!rowGroup && !!rowGroup.color) ? rowGroup.color : "#fff"

        const fontText = (!!rowGroup && !!rowGroup.color) ? fontColorContrast(rowBackgroundColor) : "#C4C4C4"

        const closedRowGroupsSet = new Set<number>(closedRowGroups)


        let found = false
        let fakingIt = false

        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            const start = parseInt(rowGroup.start)
            if(!closedRowGroupsSet.has(start) && index > start && index < rowGroup.end) {
                found = true
            }
            if(!closedRowGroupsSet.has(start) && index === rowGroup.end) {
                fakingIt = true
            }
        })

        if(found && !fakingIt) {
            return (
                <div style={{backgroundColor: fontText}} className={classes.GroupButtonDivider} />
            )
        }

        if(fakingIt) {
            return (
                <div />
            )
        }
    }

    renderGroupMenuItem = (index: number) => {
        const { rowGroups, groupRows} = this.props

        let found = false

        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            const start = parseInt(rowGroup.start)
            const end = rowGroup.end
            if(start === index) {
                found = true
            }
        })

        if(found) {
            return (
                <React.Fragment />
            )
        }

        return (
            <ContextMenuItem onClick={()=> groupRows(index)}>Group</ContextMenuItem>
        )
    }

    renderAddRowAbove = (index) => {
        const { addRowGroup } = this.props

        return (
            <ContextMenuItem onClick={()=> addRowGroup(index, 'above')}>Add Row Above</ContextMenuItem>
        )
    }

    renderDeleteRow = (index: number) => {
        const { deleteRowGroup } = this.props

        return (
            <ContextMenuItem onClick={()=> deleteRowGroup(index)}>Delete Row</ContextMenuItem>
        )
    }

    renderAddRowBelow = (index:number) => {
        const { addRowGroup } = this.props

        return (
            <ContextMenuItem onClick={()=> addRowGroup(index, 'below')}>Add Row Below</ContextMenuItem>
        )
    }

    renderMoveRowUp = (index: number) => {
        const { moveRowGroup } = this.props

        return (
            <ContextMenuItem onClick={()=> moveRowGroup(index, 'up')}>Move Row Up</ContextMenuItem>
        )
    }

    renderMoveRowDown = (index: any) => {
        const { moveRowGroup } = this.props

        return (
            <ContextMenuItem onClick={()=> moveRowGroup(index, 'down')}>Move Row Down</ContextMenuItem>
        )
    }

    renderOpenGroupDialogMenuItem = (index: number) => {
        const { rowGroups, openRowCountDialog} = this.props

        let found = false

        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            const start = parseInt(rowGroup.start)
            const end = rowGroup.end

            if(index == start) {
                found = true
            }

        })

        if(!found) {
            return (
                <React.Fragment />
            )
        }

        return (
            <ContextMenuItem onClick={()=> openRowCountDialog(index)}>Settings</ContextMenuItem>
        )
    }

    renderUnGroupMenuItem = (index: number) => {
        const { rowGroups, ungroupRows} = this.props

        let found = false

        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            const start = parseInt(rowGroup.start)
            const end = rowGroup.end

            if(index == start) {
                found = true
            }

        })

        if(!found) {
            return (
                <React.Fragment />
            )
        }

        return (
            <ContextMenuItem onClick={()=> ungroupRows(index)}>Ungroup</ContextMenuItem>
        )
    }

    renderMoveGroupUpMenuItem = (index: number) => {
        const { rowGroups, moveGroup} = this.props

        let found = false

        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            const start = parseInt(rowGroup.start)
            const end = rowGroup.end

            if(index == start) {
                found = true
            }

        })

        if(!found) {
            return (
                <React.Fragment />
            )
        }

        return (
            <ContextMenuItem onClick={()=> moveGroup(index, 'up')}>Move Group Up</ContextMenuItem>
        )
    }

    renderMoveGroupDownMenuItem = (index: number) => {
        const { rowGroups, moveGroup} = this.props

        let found = false

        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            const start = parseInt(rowGroup.start)
            const end = rowGroup.end

            if(index == start) {
                found = true
            }

        })

        if(!found) {
            return (
                <React.Fragment />
            )
        }

        return (
            <ContextMenuItem onClick={()=> moveGroup(index, 'down')}>Move Group Down</ContextMenuItem>
        )
    }

    renderContextMenu = () => {
        const { maxIndex, closedRowGroups } = this.props

        const closedRowGroupsSet = new Set<number>(closedRowGroups)

        return new Array(maxIndex+5).fill(2).map((zone, index) => {

            return (
                <ContextMenu id={`${ROW_MENU_TYPE}-${index}`} key={index}>
                    {this.renderGroupMenuItem(index)}
                    {this.renderMoveGroupUpMenuItem(index)}
                    {this.renderMoveGroupDownMenuItem(index)}

                    {this.renderMoveRowUp(index)}
                    {this.renderMoveRowDown(index)}

                    {this.renderAddRowAbove(index)}
                    {this.renderAddRowBelow(index)}
                    {this.renderDeleteRow(index)}

                    {this.renderOpenGroupDialogMenuItem(index)}

                    {this.renderUnGroupMenuItem(index)}

                </ContextMenu>
            )
        })
    }

    changeBackground = (e) => {
        e.target.style.opacity = .5;
    }

    changeBackgroundBack = (e) => {
        e.target.style.opacity = 1;

    }

    addGroupName = (rowGroup: RowGroup | Null, index: numbers) => {
        const { classes } = this.props

        const {sideOpen}  = this.state

        if(!rowGroup || !rowGroup.name || !sideOpen || rowGroup.start != index) {
            return
        }
        const rowBackgroundColor = (rowGroup.color) ? rowGroup.color : "#fff"

        const fontText = (rowGroup.color) ? fontColorContrast(rowBackgroundColor) : ""

        return <p className={classNames(classes.GroupNameText)}  style={{color: fontText}}>{rowGroup.name}</p>
    }

    closestGroup = (index: number) => {
        const { rowGroups } = this.props
        let foundGroup: RowGroup | Null = null
        Object.entries(rowGroups).forEach(([key, rowGroup]) => {
            
            const start = parseInt(rowGroup.start)
            const end = rowGroup.end
            if( index >= start && index <= end) {
                if(!foundGroup) {
                    foundGroup = rowGroup
                } else {
                    const currentDistance = rowGroup.end - rowGroup.start
                    const prevDistance = foundGroup.end - foundGroup.start
                    if(currentDistance < prevDistance) {
                        foundGroup = rowGroup
                    }
                }
            }
        })

        return foundGroup
    }

    getDropZones = () => {

            const { maxIndex, classes, rowGroups, closedRowGroups } = this.props
            const { sideOpen } = this.state

            const { width, height, margin, fontSize, titleFontSize, averagePadding } = getSize(getZoomAmount(this.props.zoomStep))
            const { rowGroupStarts } = this.props

            const rowGroupSet = new Set<number>(rowGroupStarts)

            //for debugging 
            
            const closedRowGroupsSet = new Set<number>(closedRowGroups)

            return new Array(maxIndex+10).fill(2).map((zone, index) => {
                let found = false
                Object.entries(rowGroups).forEach(([key, rowGroup]) => {

                    const start = parseInt(rowGroup.start)
                    const end = rowGroup.end
                    if(closedRowGroupsSet.has(start) && index > start && index <= end) {
                        found = true
                    }
                })

                if(found) {
                    return (
                        <React.Fragment />
                    )
                }

  
                const attributes = {
                    row: index
                }

                const sideClass = sideOpen ? classes.DateColumnNumberOpen : classes.DateColumnNumberClose

                const closestGroup = this.closestGroup(index)

                const groupButton = (sideOpen && !rowGroupSet.has(index)) ? classes.DatePadding : ""
                const rowBackgroundColor = (!!closestGroup && !!closestGroup.color) ? closestGroup.color : "#fff"

                const fontText = (!!closestGroup && !!closestGroup.color) ? fontColorContrast(rowBackgroundColor) : ""

                return (
                    <Animated key={index} animationIn="fadeIn" animationOut="fadeOut" isVisible={!found}>

                        <ContextMenuTrigger
                            row={index}
                            stuff={index}
                            holdToDisplay={-1}
                            attributes={attributes} 
                            id={`${ROW_MENU_TYPE}-${index}`}
                        >
                            <div 
                                onMouseOver={this.changeBackground}
                                onMouseLeave={this.changeBackgroundBack}

                                onClick={this.onColumnClick.bind(this, index)} className={classNames(classes.RowCountContainer, sideClass)} 
                                style={{ 
                                    height, 
                                    width: '100%',
                                    minHeight: height,
                                    marginBottom: margin,
                                    marginTop: margin,
                                    backgroundColor: rowBackgroundColor ,
                                    outlineColor: rowBackgroundColor
                                }}
                            >
                                {this.addGroupName(closestGroup, index)}
                                <div className={classNames(classes.RowCountNumberContainer)}>
                                    <div className={classNames(classes.RowCountIndicatorContainer, groupButton)} >
                                        {this.renderTopGroupIndicator(index, closestGroup)}
                                        <Typography className={classNames(classes.LookaheadTitleText)} style={{fontSize: titleFontSize, color: fontText}}>{index + 1}</Typography>
                                        {this.groupButton(index, closestGroup)}
                                        {this.renderBottomGroupIndicator(index, closestGroup)}
                                    </div>
                                </div>

                            </div>
                        </ContextMenuTrigger>
                    </Animated>
                )
            })
        }


    shouldComponentUpdate(nextProps :ColumnProps, nextState: State) {
        if(nextState.sideOpen != this.state.sideOpen) {
            return true
        }

        if(nextProps.zoom !== this.props.zoom) {
            return true
        }
        
        if(nextProps.zoomStep !== this.props.zoomStep) {
            return true
        }

        if(!_.isEqual(nextProps.closedRowGroups, this.props.closedRowGroups)) {
            return true
        }

        if(!_.isEqual(nextProps.rowGroupStarts, this.props.rowGroupStarts)) {
            return true
        }

        if(nextProps.rowGroups != this.props.rowGroups) {
            return true
        }

        if(nextProps.maxIndex !== this.props.maxIndex) {
            return true
        }

        return false
    }

    render() {
        const { classes,  zoomStep, zoom } = this.props
        const { sideOpen } = this.state
        const style = {
            overflowY:'hidden',
            transform: `scale(${zoom/100})`,
            transformOrigin: '0 0'
        };
        if(this.props.columnsWrapRef.current) {
            style.height = this.props.columnsWrapRef.current.clientHeight / (zoom/100)
        }

        const dateColumnOpen = sideOpen  ? classes.DateColumnOpen : ""

        return (
            <React.Fragment>
                {this.renderContextMenu()}

                <div 
                    style={style}
                    className={classNames(classes.PhasePlanLocationGridColumn, classes.DateColumn, dateColumnOpen, 'RowCountColumnClass')} 
                >
                        <div>
                            <div className={classNames(classes.ColumnTitle)} >
                                {this.renderTitle()}
                            </div>
                            <div className={classNames(this.props.classes.InnerColumn)}>
                                {this.getDropZones()}
                            </div>
                        </div>
                </div>
            </React.Fragment>
        )
    }
}


const mapStateToProps = (state:any, ownProps?: any) => ({
    _isHistogramOpen: isHistogramOpen(state, ownProps),
    maxIndex: getMaxIndex(state),
    rowGroups: getRowGroups(state),
    rowGroupStarts:  getRowGroupStarts(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        onRowSelect: ( row: number) => dispatch(lookaheadActions.onRowSelect(row)),
        onToggleRowGroup: (row:number) => dispatch(lookaheadActions.onToggleRowGroup(row)),
        groupRows: (initialRow: number) => dispatch(lookaheadActions.groupRows(initialRow)),
        ungroupRows: (initialRow: number) => dispatch(lookaheadActions.ungroupRows(initialRow)),
        openRowCountDialog: (row: number) => dispatch(dialogActions.openRowCountDialog(row)),
        addRowGroup: (index:number, direction: string) => dispatch(lookaheadActions.addRowGroup(index, direction)),
        moveRowGroup: (index:number, direction: string) => dispatch(lookaheadActions.moveRowGroup(index, direction)),
        moveGroup: (index:number, direction: string) => dispatch(lookaheadActions.moveGroup(index, direction)),
        deleteRowGroup: (index:number) => dispatch(lookaheadActions.deleteRowGroup(index))

    }
};

const MyInput = React.forwardRef((props, ref) => {
    return (<_RowCountColumn forwardedRef={ref} {...props} />);
  })

export const RowCountColumn = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true })
)(MyInput)


// WEBPACK FOOTER //
// ./src/components/PhasePlan/RowCountColumn.tsx